// extracted by mini-css-extract-plugin
export default {"characteristics":"FirstBlock_characteristics__QYFAk","button":"FirstBlock_button__zE54L"};